import React from "react";
import {
  CircularProgress,
  TextField,
  Box,
  makeStyles,
  Theme,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useNoteTypes } from "../../../projectQueries";
import { ErrorMessage } from "../../../../common/ErrorMessage";
import { getTheme } from "../../../../common/getLocalTheme";

const useStyles = makeStyles((theme: Theme) => ({
  autocompleteInput: {
    backgroundColor: "#ffffff",
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    transition: "border-color 0.2s ease-in-out",
    "&:hover": {
      borderColor: "#cbd5e1",
    },
    "& .MuiOutlinedInput-root": {
      padding: "6px 12px !important",
      borderRadius: 8,
      "& fieldset": {
        border: "none",
      },
    },
    "& .MuiInputBase-input": {
      fontSize: "0.9rem",
      color: "#1e293b",
      fontWeight: 400,
    },
  },
}));



export const NoteTypeSection = ({
  noteType,
  setNoteType,
}:any) => {
  const classes = useStyles();

  const {
    data: noteTypesData = [],
    error: noteTypesError,
    isLoading: isLoadingNoteTypes,
    isError: isErrorNoteTypes,
  } = useNoteTypes("Threaded Notes");

  const handleChange = (newNoteType:any) => {
    if (newNoteType) {
      setNoteType(newNoteType.id);
    }
  };

  if (isLoadingNoteTypes) {
    return (
      <Box display="flex" alignItems="center" padding={1}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (isErrorNoteTypes) {
    return <ErrorMessage error={noteTypesError} />;
  }

  const selectedValue =
    noteTypesData?.results?.find((item: any) => item.id === noteType) || null;

  return (
    <Autocomplete
      id="noteType"
      options={noteTypesData?.results || []}
      getOptionLabel={(option: any) => option.visible_name || ""}
      value={selectedValue}
      onChange={(_, newValue) => handleChange(newValue)}
      disabled={getTheme()}
      fullWidth
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Select type"
          variant="outlined"
          data-testid="noteType"
          className={classes.autocompleteInput}
        />
      )}
    />
  );
};